export interface Category {
  slug: string;
  name: string;
  icon: string;
  count: number;
  description: string;
}

export const categories: Category[] = [
  {
    slug: 'action',
    name: '热血少年',
    icon: 'ri-sword-line',
    count: 4,
    description: '战斗、冒险、成长——热血少年漫画点燃你的斗志',
  },
  {
    slug: 'romance',
    name: '浪漫爱情',
    icon: 'ri-heart-line',
    count: 5,
    description: '甜宠、虐恋、治愈——浪漫爱情故事温暖你的心',
  },
  {
    slug: 'thriller',
    name: '悬疑惊悚',
    icon: 'ri-ghost-line',
    count: 3,
    description: '恐怖、悬疑、推理——紧张刺激让你欲罢不能',
  },
];